import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { IGridCard } from './../FilterableGridModule.types';
import GenericCard from '@/components/GenericCard/GenericCard.vue';
@Component({
  components: {
    GenericCard,
  },
})
export default class FilterableGrid extends Vue {
  @Prop()
  readonly cards!: IGridCard[];

  @Prop()
  readonly isMasonry: Boolean;

  @Prop()
  readonly resetCardState!: Boolean;

  @Prop()
  readonly NoteText!: String;
}
